module.exports = __webpack_public_path__ + "static/media/pdrl.193e0679.png";